<template>
  <v-container
    fluid
    class="mt-5"
  >
    <v-layout
      align-center
      justify-center
    >
      <div class="mr-3 hidden-sm-and-down">
        <img
          src="/static/error/404.svg"
          alt=""
          s
        >
      </div>
      <div class="text-md-center">
        <h1>404</h1>
        <h2 class="my-3 headline ">
          {{ $t('Sorry, data not found') }}
        </h2>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'DataNotFound'
}
</script>
